export const groupTracks = [
  { id: '0', name: 'Troncal', value: 'trunk' },
  { id: '1', name: 'Rotonda', value: 'roundabout' },
  { id: '2', name: 'Ramal entrada', value: 'input branch' },
  { id: '3', name: 'Ramal sortida', value: 'exit branch' },
  { id: '4', name: 'Via de servei', value: 'service road' },
  { id: '5', name: 'Calçada', value: 'roadway' },
  { id: '6', name: 'Voral', value: 'shoulder' },
  { id: '7', name: 'Fora calçada', value: 'off roadway' },
  { id: '8', name: 'Túnel', value: 'tunnel' },
  { id: '9', name: 'Enllaç', value: 'link' },
  { id: '10', name: 'ADR', value: 'ADR' },
  { id: '11', name: 'JC', value: 'JC' },
  { id: '12', name: 'FF', value: 'FF' },
  { id: '13', name: 'SJ', value: 'SJ' },
  { id: '14', name: 'RM', value: 'RM' },
  { id: '15', name: 'BC', value: 'BC' },
  { id: '16', name: 'ES', value: 'ES' },
  { id: '17', name: 'CR', value: 'CR' },
  { id: '18', name: 'PG', value: 'PG' },
  { id: '19', name: 'LC', value: 'LC' },
  { id: '20', name: 'JT', value: 'JT' },
  { id: '21', name: 'BG', value: 'BG' },
  { id: '22', name: 'LF', value: 'LF' },
  { id: '23', name: 'Edifici Cons.', value: 'building cons.' },
  { id: '24', name: 'Àrea servei', value: 'service area' },
  { id: '25', name: 'Sense especificar', value: 'sense especificar' },
];

export const groupLanes = [
  { id: '0', name: 'Dret', value: 'right' },
  { id: '1', name: 'Esquerre', value: 'left' },
  { id: '2', name: 'Central', value: 'central' },
  { id: '3', name: 'Ambdós', value: 'both' },
  { id: '4', name: 'Sense especificar', value: 'unspecified' },
];

export const specialTagType = [
  { id: '0', name: 'Recorregut de vigilància', value: 'surveillanceRoute' },
  { id: '1', name: 'Campanya', value: 'campaign' },
];

export const hoursType = [
  { id: '0', name: 'Normals', value: 'normal' },
  { id: '1', name: 'Extres normals', value: 'normalExtras' },
  { id: '2', name: 'Extres festius', value: 'holidayExtras' },
  { id: '3', name: 'Extres festius RV', value: 'holidayExtrasRV' },
  { id: '4', name: 'Extres normals VH', value: 'normalExtrasRV' },
  { id: '5', name: 'Extres festius VH', value: 'holidayExtrasVH' },
  { id: '6', name: 'Sense especificar', value: 'sense especificar' },
];
